import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQueryBig = (style) => {
  return `
    ${BaSeTheme.breakpoints.desktop.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.desktopLarge.mediaQueryCss(style)};
  `;
};

export const Container = styled.div`
  display: flex;
  justify-content: center;

  ${handleQueryBig(`
    justify-content: start;
  `)}
  ${({ withBorder, borderColor }) =>
    withBorder
      ? css`
          .BaSe--button {
            border: 1px solid ${borderColor};
          }
        `
      : css`
          .BaSe--button {
            border: none;
          }
        `}
`;
